import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import DealsCard from './DealsCard'
import { Droppable } from 'react-beautiful-dnd';
import { getDealsApi, } from "api/SalesApi"



let Container = styled.div`
  margin : 8px;
  border : none;
  border-radius : 4px;
  min-width : 300px;
  display : flex;
  flex-direction : column;
`;
const Title = styled.div`
  padding : 8px;
  margin-bottom : 0px;
  font-size: 12px;
  font-weight: 600;
  margin:10px;
  color:#18181F;
  border-radius: 4px;
`;
const DealsList = styled.div`
  padding : 8px;
  flex-grow : 1;
  transition : background-color 0.2s ease;
  background-color : ${props => (props.isDraggingOver ? 'rgba(240,240,240,1)' : '#F5F6F8')};
  min-height : 100px;
`;
const HorizontalLine = styled.div`
  width : 100%;
  height : 1px;
  background-color : rgba(240,240,240,1);
`;






export default function DealsStages({ stage, setShowDealModal,headcolor }) {
  return (
    <Container style={{backgroundColor:`#F5F6F8`, fontSize:"12px !important"}}>
      <Title style={{backgroundColor:`${headcolor}`}}><div style={{display:"flex", justifyContent:"space-between"}} > <span> {stage.label}</span> <div className='dijeihwd'>{ stage.deals &&  stage.deals.length}</div>  </div></Title>
      {/* <HorizontalLine /> */}
      <Droppable
        droppableId={stage.id}
      >
        {(provided, snapshot) => (
          <DealsList
            ref={provided.innerRef}
            {...provided.droppableProps}
            isDraggingOver={snapshot.isDraggingOver}
          >
            {
              // Deals should be mapped here
              stage.deals.length > 0 && stage.deals.map((deal, index) => (
                <DealsCard index={index} deal={deal} setShowDealModal={setShowDealModal} />
              )
              )
            }
            {provided.placeholder}
          </DealsList>
        )}
      </Droppable>
    </Container>
  )
}
